import { AxDropdown, AxFormValidation, AxInput } from "@axess/limestone";
import { MaskedTextChangedListener } from 'ts-input-mask';
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import { ConfigDefinition, ConfigHelper } from "../../../../Lib/Helper/Config/ConfigHelper";
import { I18nHelper, Translations } from "../../../../Lib/Helper/I18nHelper";
import { MeasurementHelper } from "../../../../Lib/Helper/MeasurementHelper";
import * as models from "../RiderDetailsModelBundle";
import * as Rental from "../RiderDetailsModule";

export class PersonDataForm {
    private formName = '#personDataForm';

    private unitSystem: number;

    private heightDropDown = new AxDropdown();
    private weightDropDown = new AxDropdown();
    private shoeSizeDropDown = new AxDropdown();
    private shoeSizeSystemDropDown = new AxDropdown();

    private countryDropDown = new AxDropdown();
    private genderDropDown = new AxDropdown();
    private skillLevelDropDown = new AxDropdown();

    private riderDetailsModule: Rental.RiderDetailsModule;

    private measurementHelper: MeasurementHelper = new MeasurementHelper();

    constructor(unitSystem: number) {
        this.unitSystem = unitSystem;
        this.riderDetailsModule = AxLoad.GetModule<Rental.RiderDetailsModule>("RiderDetailsModule");
    }

    async initInputsAsync(productAndRiderDetails: models.ProductAndRiderDetails) {
        return new Promise<void>((resolve) => {
            this.initInputValidation();
            this.initUnitSelectionRadios(productAndRiderDetails);

            ConfigHelper.getBoolConfigValueAsync(ConfigDefinition.RentalDataTextInput)
                .then(async useTextInput => {
                    if (productAndRiderDetails != null &&
                        productAndRiderDetails.riderData != null &&
                        productAndRiderDetails.riderData != undefined) {
                        this.initTextInputs(productAndRiderDetails, useTextInput);
                        this.initDropDowns(productAndRiderDetails, useTextInput);
                        await this.setValueFromProductAndRiderDetailsToForm(productAndRiderDetails, useTextInput);
                        resolve();
                    }
                });
        });
    }

    private initInputValidation() {
        let validationFormOptions = {
            selector: '#personDataForm',
            rules: this.getValidationRules(),
            callback: (form: HTMLElement) => {
                //this.submitPersonDataForm();
            }
        }

        const $form = $('#personDataForm');

        const $inputs = $form.find(".ax-form-control");

        new AxFormValidation(validationFormOptions).init();

        for (let i = 0; i < $inputs.length; i++) {
            const input = $inputs.get(i) as HTMLInputElement;

            if (input.id.length === 0) {
                continue;
            }

            new AxInput('#' + input.id).init();
        }

        const i18nHelper = new I18nHelper();

        $("#heightFeet, #heightInch").on("keyup change", function () {
            const otherField = this.id === "heightFeet" ? "#heightInch" : "#heightFeet";
            $(otherField).valid();
        });

        $.validator.addMethod(
            "maxHeight",
            (value, element, params) => {
                const feet = Number($("#heightFeet").val() as string);
                const inches = Number($("#heightInch").val() as string);

                const totalInches = this.measurementHelper.feetAndInchesToTotalInches(feet, inches);
                const maxInches = this.measurementHelper.feetAndInchesToTotalInches(params.maxFeet, params.maxInches);

                return totalInches <= maxInches;
            },
            (params) => i18nHelper.GetTranslation(Translations.MaxRentalHeight, params.maxFeet, params.maxInches)
        );
    }

    private initUnitSelectionRadios(productAndRiderDetails: models.ProductAndRiderDetails) {
        const radios: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[name="unit"]');

        radios.forEach((radio) => {
            radio.addEventListener('change', (e) => {
                const selectedVal = $(e.currentTarget as EventTarget).val();
                productAndRiderDetails.riderData.unitSystem = Number(selectedVal);
                this.riderDetailsModule.loadAccountData(productAndRiderDetails.customerAccountNr);
            });
        });
    }

    private initTextInputs(productAndRiderDetails: models.ProductAndRiderDetails, useTextInput: boolean) {
        if ($('#City').length > 0) {
            $('#City').on('input', e => {
                productAndRiderDetails.riderData.city = $('#City').val() as string;
            });
        }

        if ($('#Phone').length > 0) {
            $('#Phone').on('input', e => {
                productAndRiderDetails.riderData.phone = $('#Phone').val() as string;
            });
        }

        if ($('#State').length > 0) {
            $('#State').on('input', e => {
                productAndRiderDetails.riderData.state = $('#State').val() as string;
            });
        }

        if ($('#Street').length > 0) {
            $('#Street').on('input', e => {
                productAndRiderDetails.riderData.street = $('#Street').val() as string;
            });
        }

        if ($('#ZipCode').length > 0) {
            $('#ZipCode').on('input', e => {
                productAndRiderDetails.riderData.zipCode = $('#ZipCode').val() as string;
            });
        }

        if (useTextInput) {
            if (this.unitSystem === 1) // imperial == 1
            {
                if ($('#heightFeet').length > 0 || $('#heightInch').length > 0) {
                    $('#heightFeet, #heightInch').on('input', () => {
                        const feet = Number($('#heightFeet').val());
                        const inches = Number($('#heightInch').val());

                        const totalInches = this.measurementHelper.feetAndInchesToTotalInches(feet, inches);
                        productAndRiderDetails.riderData.height = this.measurementHelper.inchesToMeters(totalInches);
                    });
                }

                if ($('#Weight').length > 0) {
                    $('#Weight').on('input', e => {
                        const weightInLbs = Number($('#Weight').val() as string);
                        productAndRiderDetails.riderData.weight = this.measurementHelper.lbsToKg(weightInLbs);
                    });
                }
            } else {
                if ($('#Height').length > 0) {
                    $('#Height').on('input', e => {
                        const heightInMeter = Number($('#Height').val() as string);
                        productAndRiderDetails.riderData.height = heightInMeter;
                    });
                }

                if ($('#Weight').length > 0) {
                    $('#Weight').on('input', e => {
                        productAndRiderDetails.riderData.weight = Number($('#Weight').val() as string);
                    });
                }
            }
        }
    }

    private initDropDowns(productAndRiderDetails: models.ProductAndRiderDetails, useTextInput: boolean) {
        this.initCountryDropDown(productAndRiderDetails);
        this.initGenderDropDown(productAndRiderDetails);
        this.initSkillLevelDropDown(productAndRiderDetails);
        this.initShoeSizeSystemDropDown(productAndRiderDetails);
        this.initShoeSizeDropDown(productAndRiderDetails);

        if (!useTextInput) {
            this.initHeightDropDown(productAndRiderDetails);
            this.initWeightDropDown(productAndRiderDetails);
        }
    }

    private async setValueFromProductAndRiderDetailsToForm(productAndRiderDetails: models.ProductAndRiderDetails, useTextInput: boolean) {
        return new Promise<void>((resolve) => {

            if ($('#City').length > 0) {
                $('#City').val(productAndRiderDetails.riderData.city);
                $('#City').text(productAndRiderDetails.riderData.city);
            }

            if ($('#Phone').length > 0) {
                $('#Phone').val(productAndRiderDetails.riderData.phone);
                $('#Phone').text(productAndRiderDetails.riderData.phone);
            }

            if ($('#State').length > 0) {
                $('#State').val(productAndRiderDetails.riderData.state);
                $('#State').text(productAndRiderDetails.riderData.state);
            }

            if ($('#Street').length > 0) {
                $('#Street').val(productAndRiderDetails.riderData.street);
                $('#Street').text(productAndRiderDetails.riderData.street);
            }

            if ($('#ZipCode').length > 0) {
                $('#ZipCode').val(productAndRiderDetails.riderData.zipCode);
                $('#ZipCode').text(productAndRiderDetails.riderData.zipCode);
            }

            if (useTextInput) {
                const { height, weight } = productAndRiderDetails.riderData ?? {};

                if (this.unitSystem === 1) { // Imperial
                    if (height != null) {
                        const totalInches = this.measurementHelper.metersToInches(height);
                        const feet = Math.floor(totalInches / 12);
                        const inches = Math.round(totalInches % 12);

                        $('#heightFeet').val(feet).trigger('change');
                        $('#heightInch').val(inches).trigger('change');
                    }

                    if (weight != null) {
                        const weightLbs = this.measurementHelper.kgToLbs(weight);
                        $('#Weight').val(weightLbs).trigger('change');
                    }
                } else { // Metric
                    if ($('#Height').length > 0 && height != null) {
                        this.applyMeterMask($('#Height')[0] as HTMLInputElement);
                        $('#Height').val(height).trigger('change');
                    }

                    if ($('#Weight').length > 0 && weight != null) {
                        const weightKg = Math.round(weight * 100) / 100;
                        $('#Weight').val(weightKg).trigger('change');
                    }
                }
            }

            resolve();
        });
    }

    hasForm(): boolean {
        if ($(this.formName).length === 0) {
            return false;
        } else {
            return true;
        }
    }

    formIsValid(): boolean {
        let valid = $(this.formName)?.valid();
        return valid;
    }

    setEmptyValues(productAndRiderDetails: models.ProductAndRiderDetails) {
        productAndRiderDetails.riderData = new models.RiderData();
        productAndRiderDetails.riderData.customerName = "name";
        productAndRiderDetails.riderData.customerEmail = "mail";
    }

    private initShoeSizeSystemDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-shoeSizeSystem').length === 0) {
            return;
        }

        this.shoeSizeSystemDropDown = new AxDropdown();
        this.shoeSizeSystemDropDown.init(`.rental_customer_details-shoeSizeSystem`, {
            searchBar: false,
            multiSelect: false,
            onSelect: (elem: any) => {
                try {
                    const value = this.shoeSizeSystemDropDown.getValue().toString();
                    if (productAndRiderDetails.riderData.shoeSizeSystem !== Number(value)) {
                        productAndRiderDetails.riderData.shoeSizeSystem = Number(value);
                        this.riderDetailsModule.loadAccountData(productAndRiderDetails.customerAccountNr);
                    }
                } catch (e) { return; }
            },
        });

        if (productAndRiderDetails.riderData.shoeSizeSystem != undefined || productAndRiderDetails.riderData.shoeSizeSystem != null) {
            this.shoeSizeSystemDropDown.setValue(productAndRiderDetails.riderData.shoeSizeSystem.toString());
        }
    }

    private initHeightDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-height').length === 0) {
            return;
        }

        this.heightDropDown = new AxDropdown();
        this.heightDropDown.init(`.rental_customer_details-height`, {
            searchBar: false,
            multiSelect: false,
            onSelect: (elem: any) => {
                try {
                    const value = this.heightDropDown.getValue().toString();
                    $('#Height').val(value);
                    productAndRiderDetails.riderData.height = Number(value);
                } catch (e) { return; }
            },
        });

        if (productAndRiderDetails.riderData.height != undefined || productAndRiderDetails.riderData.height != null) {
            this.heightDropDown.setValue(productAndRiderDetails.riderData.height.toString());
        }
    }

    private initShoeSizeDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-shoeSize').length === 0) {
            return;
        }

        this.shoeSizeDropDown = new AxDropdown();
        this.shoeSizeDropDown.init(`.rental_customer_details-shoeSize`, {
            searchBar: false,
            multiSelect: false,
            onSelect: (elem: any) => {
                try {
                    const value = this.shoeSizeDropDown.getValue().toString();
                    $('#ShoeSize').val(value);
                    productAndRiderDetails.riderData.shoeSize = Number(value);
                } catch (e) { return; }
            },
        });

        if (productAndRiderDetails.riderData.shoeSize != undefined || productAndRiderDetails.riderData.shoeSize != null) {
            this.shoeSizeDropDown.setValue(productAndRiderDetails.riderData.shoeSize.toString());
        }
    }

    private initWeightDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-weight').length === 0) {
            return;
        }

        this.weightDropDown = new AxDropdown();
        this.weightDropDown.init(`.rental_customer_details-weight`, {
            searchBar: false,
            multiSelect: false,
            onSelect: (elem: any) => {
                try {
                    const value = this.weightDropDown.getValue().toString();
                    $('#Weight').val(value);
                    productAndRiderDetails.riderData.weight = Number(value);
                } catch (e) { return; }
            },
        });

        if (productAndRiderDetails.riderData.weight != undefined || productAndRiderDetails.riderData.weight != null) {
            this.weightDropDown.setValue(productAndRiderDetails.riderData.weight.toString());
        }
    }

    private initCountryDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-country').length === 0) {
            return;
        }

        this.countryDropDown = new AxDropdown();
        this.countryDropDown.init(`.rental_customer_details-country`, {
            searchBar: false,
            multiSelect: false,
            onSelect: (elem: any) => {
                const value = this.countryDropDown.getValue().toString();
                $('#CustomerCountry').val(value);
                productAndRiderDetails.riderData.country = value;
            },
        });

        if (productAndRiderDetails.riderData.country != undefined || productAndRiderDetails.riderData.country != null) {
            this.countryDropDown.setValue(productAndRiderDetails.riderData.country);
        }
    }

    private initGenderDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-gender').length === 0) {
            return;
        }

        this.genderDropDown = new AxDropdown();
        this.genderDropDown.init(`.rental_customer_details-gender`, {
            searchBar: true,
            multiSelect: false,
            onSelect: (elem: any) => {
                const value = this.genderDropDown.getValue().toString();
                $('#Gender').val(value);
                productAndRiderDetails.riderData.gender = value;
            }
        });

        if (productAndRiderDetails.riderData.gender != undefined || productAndRiderDetails.riderData.gender != null) {
            this.genderDropDown.setValue(productAndRiderDetails.riderData.gender);
        }
    }

    private initSkillLevelDropDown(productAndRiderDetails: models.ProductAndRiderDetails) {
        if ($('.rental_customer_details-skillLevel').length === 0) {
            return;
        }

        this.skillLevelDropDown = new AxDropdown();
        this.skillLevelDropDown.init(`.rental_customer_details-skillLevel`, {
            searchBar: false,
            multiSelect: false,
            onSelect: (elem: any) => {
                const value = this.skillLevelDropDown.getValue().toString();
                $('#SkillLevel').val(value);
                productAndRiderDetails.riderData.skillLevel = Number(value);
            },
        });

        if (productAndRiderDetails.riderData.skillLevel != undefined || productAndRiderDetails.riderData.skillLevel != null) {
            this.skillLevelDropDown.setValue(productAndRiderDetails.riderData.skillLevel.toString());
        }
    }

    private getValidationRules(): JQueryValidation.RulesDictionary {
        return {
            hiddenPhone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/
            },
            phone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/,
                normalizer: function (value) {
                    let dropdownVal = $(this).parents(".ax-phone-field").find(".hidden-input").val() as string;
                }
            },
            email: {
                required: true,
                email: true,
                regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
            },
            heightFeet: {
                number: true,
                maxHeight: {
                    maxFeet: 7,
                    maxInches: 0
                }
            },
            heightInch: {
                number: true,
                max: 11,
                maxHeight: {
                    maxFeet: 7,
                    maxInches: 0
                }
            },
            Weight: {
                number: true,
                max: this.unitSystem === 1 ? 400 : 181,
            },
            Height: {
                number: true,
                max: 2.10
            },
        };
    }

    applyMeterMask(inputElement: HTMLInputElement) {
        const meterFormat = "[0].[00]";
        //const feetAndInchesFormat = '9999\'99"';

        const listener = MaskedTextChangedListener.installOn(meterFormat, inputElement,
            new class implements MaskedTextChangedListener.ValueListener {
                public onTextChanged(maskFilled: boolean, extractedValue: string, formattedText: string): void {
                    $('#Height').trigger('input');
                }
            }(),
            [], // affineFormats
            [], // customNotations
            undefined, // affinityCalculationStrategy
            true // autocomplete
        );
    }

    applyFeetAndInchesMask(inputElement: HTMLInputElement) {
        const feetAndInchesFormat = "[00]' [00]''";
        //const feetAndInchesFormat = '9999\'99"';

        const listener = MaskedTextChangedListener.installOn(feetAndInchesFormat, inputElement,
            new class implements MaskedTextChangedListener.ValueListener {
                public onTextChanged(maskFilled: boolean, extractedValue: string, formattedText: string): void {
                    $()
                }
            }(),
            [], // affineFormats
            [], // customNotations
            undefined, // affinityCalculationStrategy
            true // autocomplete
        );
    }
}